import BrowserNotSupported from '@/views/BrowserNotSupported.vue';
import ConnectToNotion from '@/views/ConnectToNotion.vue';
import ExtensionLogin from '@/views/ExtensionLogin.vue';
import ExtensionView from '@/views/ExtensionView.vue';
import HomeView from '@/views/HomeView.vue';
import NotFoundView from '@/views/NotFoundView.vue';
import PlansView from '@/views/PlansView.vue';
import PlaygroundView from '@/views/PlaygroundView.vue';
import RegisterView from '@/views/RegisterView.vue';
import Sidepanel from '@/views/Sidepanel.vue';
import routeNames from '@/router/routes';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'not found',
    component: NotFoundView,
    meta: { auth: false, needsCertainBrowser: false },
  },
  {
    path: '/browser-not-supported',
    name: routeNames.unsupportedBrowser,
    component: BrowserNotSupported,
    meta: { auth: false, needsCertainBrowser: false },
  },
  {
    path: '/sidepanel',
    name: routeNames.sidepanel,
    component: Sidepanel,
    meta: { auth: true, needsCertainBrowser: true, layout: 'plain' },
  },
  {
    path: '/plans',
    name: routeNames.plans,
    component: PlansView,
    meta: { auth: true, needsCertainBrowser: false },
  },
  {
    path: '/extension-login',
    name: routeNames.extensionLogin,
    component: ExtensionLogin,
    meta: { auth: false, needsCertainBrowser: true },
  },
  {
    path: '/connect-to-notion',
    name: routeNames.connectToNotion,
    component: ConnectToNotion,
    meta: { auth: true, needsCertainBrowser: true, layout: 'plain' },
  },
  {
    path: '/register',
    name: routeNames.register,
    component: RegisterView,
    meta: { auth: false, needsCertainBrowser: true },
  },
  {
    path: '/playground',
    name: 'playground',
    component: PlaygroundView,
    meta: { auth: false, needsCertainBrowser: false },
  },
  {
    path: '/extension',
    name: 'Extension test',
    component: ExtensionView,
    meta: { auth: false, needsCertainBrowser: false },
  },
  {
    path: '/',
    name: routeNames.home,
    component: HomeView,
    meta: {
      auth: true,
      needsCertainBrowser: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory('/app'),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.needsCertainBrowser) {
    return next();
  }
  if (window.chrome === undefined) {
    return next({ name: routeNames.unsupportedBrowser });
  }

  return next();
});

export default router;
